/**
 * Small visual chip that labels an ETF's community-defined type.
 * If `onClick` is provided, renders as a button that opens the
 * "all ETFs of this type" side-panel via the parent's handler.
 */
import { Info } from "lucide-react";

export default function EtfTypeChip({ type, size = "md", showInfo = false, onClick }) {
  if (!type || !type.id || !type.label) return null;
  const sz =
    size === "sm"
      ? "text-[9px] px-1.5 py-0.5"
      : size === "lg"
      ? "text-[11px] px-2.5 py-1"
      : "text-[10px] px-2 py-0.5";

  const baseStyle = {
    color: type.color,
    borderColor: `${type.color}66`,
    background: `${type.color}14`,
  };

  const inner = (
    <>
      <span
        className="inline-block w-1.5 h-1.5 rounded-full"
        style={{ background: type.color }}
      />
      {type.label}
      {showInfo && <Info size={10} className="opacity-60 ml-0.5" />}
    </>
  );

  const className = `inline-flex items-center gap-1 font-mono uppercase tracking-widest border ${sz}`;

  if (typeof onClick === "function") {
    return (
      <button
        type="button"
        data-testid={`etf-type-chip-${type.id}`}
        title={`Browse all ${type.label} ETFs by AUM`}
        onClick={(e) => {
          e.stopPropagation();
          onClick(type);
        }}
        className={`${className} cursor-pointer transition-all hover:opacity-90 hover:shadow-[0_0_0_3px_rgba(255,255,255,0.04)] active:scale-[0.97]`}
        style={baseStyle}
      >
        {inner}
      </button>
    );
  }

  return (
    <span
      data-testid={`etf-type-chip-${type.id}`}
      title={type.blurb || type.label}
      className={className}
      style={baseStyle}
    >
      {inner}
    </span>
  );
}
